window.TNWSCartRestore = (function () {
  const STORAGE_KEY = 'tnws_saved_cart';
  const MAX_AGE_MS = 24 * 60 * 60 * 1000;

  function mapItemForAdd(item) {
    const payload = {
      id: item.variant_id || item.id,
      quantity: item.quantity,
    };

    if (item.properties && Object.keys(item.properties).length) {
      payload.properties = item.properties;
    }

    if (item.selling_plan) {
      payload.selling_plan = item.selling_plan;
    }

    return payload;
  }

  function getSavedCart() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (!parsed?.items?.length) return null;

      if (Date.now() - (parsed.savedAt || 0) > MAX_AGE_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return parsed;
    } catch (error) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
  }

  function clearSavedCart() {
    sessionStorage.removeItem(STORAGE_KEY);
  }

  async function saveCurrentCart() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;

      const cart = await response.json();
      if (!cart.items?.length) return;

      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          savedAt: Date.now(),
          items: cart.items,
        })
      );
    } catch (error) {
      console.error('TNWS: could not save cart', error);
    }
  }

  async function restoreSavedCart() {
    const saved = getSavedCart();
    if (!saved) return false;

    try {
      const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const clearData = await clearResponse.json();
      if (clearData?.status) throw new Error(clearData.description || 'Could not restore cart.');

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: saved.items.map(mapItemForAdd),
        }),
      });
      const addData = await addResponse.json();
      if (addData?.status) throw new Error(addData.description || 'Could not restore cart.');

      clearSavedCart();

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tnws-cart-restore', cartData: addData });
      }

      return true;
    } catch (error) {
      console.error('TNWS: could not restore cart', error);
      return false;
    }
  }

  function shouldAttemptRestore() {
    const path = window.location.pathname;
    if (path.startsWith('/checkout') || path.startsWith('/checkouts')) return false;
    return !!getSavedCart();
  }

  function init() {
    if (!shouldAttemptRestore()) return;
    restoreSavedCart();
  }

  return {
    saveCurrentCart,
    restoreSavedCart,
    clearSavedCart,
    init,
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  window.TNWSCartRestore?.init();
});
